namespace SP.Data {
    export class Audit {

        //private static arrivalInfo: { [arrivalId: string]: ArrivalInfo } = {};

        static async getAuditZoneInfos(): Promise<SP.AuditZoneInfo[]> {
            var response = await SP.get<any>("/api/v1/info/auditZoneInfos");
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }


        static async getAuditZonePlacementDatas(zoneId: string, currentPlacementId: number, maxResults: number): Promise<SP.AuditZoneInfo> {
            var response = await SP.get<any>(`/api/v1/info/auditZonePlacementDatas?zoneId=${zoneId}&placementId=${currentPlacementId ?? ''}&maxResults=${maxResults}`);
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }

    }
}


